import {useEffect, useState} from "react";
import {get} from "../../../controlers/global/ConfigRequest";
import {ReactComponent as CategoryIcon} from "./../../../asset/icons/basket-category.svg";
import {GET_MARKET_CATEGORIES} from "../../../helperData/ApiAddress";
import {useTranslation} from "react-i18next";

export default function Category({onClick}) {
  const [categories, setCategories] = useState(undefined);
  const [floatingMenu, setFloatingMenu] = useState(false);
  const [zalam, setZalam] = useState(0);
  const {t} = useTranslation();

  useEffect(() => {
    get(GET_MARKET_CATEGORIES).then((r) => {
      setCategories(r);
    });
  }, []);

  useEffect(() => {
    setFloatingMenu(false);
  }, [onClick]);

  const floatingMenuHandle = (e, index) => {
    setFloatingMenu(index);
    const buttonPosition = e.target.getBoundingClientRect();
    console.log(buttonPosition);
    setZalam(buttonPosition.left + buttonPosition.width / 2 - 50);
  };

  return (
    <div className="basket-category-container">
      {categories && (
        <div className="basket-category">
          <div>
            <CategoryIcon/>
            <h3>
              {t("Organizational.SellingBasket.AllCategories.List.Label")}
            </h3>
          </div>
          <div>
            {categories.map((item, index) => (
              <button
                key={index}
                onClick={(e) => floatingMenuHandle(e, index)}
              >
                {item.name}
              </button>
            ))}
          </div>
        </div>
      )}
      <div
        className={
          "floating-menu-backdrop" +
          (floatingMenu !== false ? " open" : " close")
        }
        onClick={(_) => setFloatingMenu(false)}
      ></div>
      <div
        className={
          "floating-menu" +
          (floatingMenu !== false ? " open" : " close")
        }
      >
        <div className="zalam" style={{left: zalam + "px"}}></div>
        {floatingMenu !== false && (
          <div>{categories[floatingMenu].name}</div>
        )}
        <div className="floating-menu-container">
          {floatingMenu !== false &&
            categories[floatingMenu]?.children.map((item, index) => (
              <div key={index}>
                <div onClick={() => onClick(item.name)}>
                  {item.name}
                </div>
                <ul>
                  {item.children.map((innerItem, idx) => (
                    <li key={idx}>
                      <button
                        onClick={() =>
                          onClick(innerItem.name)
                        }
                      >
                        {innerItem.name}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}
